import React from 'react';
import { motion } from 'framer-motion';
import { DatabaseZap } from 'lucide-react';

/**
 * Reusable empty state component with animation
 */
const EmptyState = ({ 
  icon: Icon = DatabaseZap,
  title = 'No data',
  description = 'No items found',
  searchTerm = '',
  actionButton = null
}) => (
  <motion.div 
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    className="text-center py-12 px-6"
  >
    <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-slate-800/80 flex items-center justify-center border border-slate-700/50">
      <Icon className="h-8 w-8 text-emerald-400 opacity-80" />
    </div>
    <h3 className="text-lg font-medium text-white mb-2">{title}</h3>
    <p className="text-slate-400 max-w-xs mx-auto">
      {searchTerm ? `No results matching "${searchTerm}"` : description}
    </p>
    
    {actionButton && (
      <div className="mt-6">
        {actionButton}
      </div>
    )}
  </motion.div>
);

export default React.memo(EmptyState);